import React,{ createContext, useContext } from 'react';

const CommonContext = createContext({});

export const CommonProvider = (props) => {
	return (
		<CommonContext.Provider
			value={props.data}
		>
			{props.children}
		</CommonContext.Provider>
	)
};

export const useCommon = () => {
	return useContext(CommonContext);
};